module.exports = __webpack_public_path__ + "static/media/SHPE R2 Copa Del Sol Soccer Tournament 2024.78554ed1.jpg";